import { Form, Input, Select } from "antd";
import { useEffect } from "react";
import { useLazyGetProductCategoryListQuery } from "../../../redux/api/SystemApi";
import { StartStatus } from "../../auction/types";
import { ReactComponent as Search } from '../../../assets/images/Search.svg';
import { useNavigate } from "react-router-dom";

const HomeSearch = () => {
    const [form] = Form.useForm();
    const [categoryTrigger, categoryResponse] = useLazyGetProductCategoryListQuery();
    const navigate = useNavigate();

    useEffect(() => {
        categoryTrigger({
            page: 0, size: 1000
        })
    }, [categoryTrigger])

    const onFinish = (values: any) => {
        // Submit tìm kiếm

        if (values.startStatus === StartStatus.UPCOMING) {
            navigate("/auction-list/upcoming", { state: { ...values } })
        } else if (values.startStatus === StartStatus.ONGOING) {
            navigate("/auction-list/ongoing", { state: { ...values } })
        } else if (values.startStatus === StartStatus.FINISH) {
            navigate("/auction-list/finish", { state: { ...values } })
        }
    }

    return (
        <div className="responsive-padding-1440">
            <Form
                className="home-search-form"
                initialValues={{ startStatus: 1 }}
                form={form}
                onFinish={onFinish}
                layout="inline"
                style={{ flexWrap: 'nowrap', marginTop: -430 }}
            >
                <Form.Item name="categoryCodes">
                    <Select
                        maxTagCount={"responsive"}
                        maxTagTextLength={15}
                        allowClear
                        className="custom-select home-search-select"
                        placeholder="Nhóm tài sản"
                        mode="multiple"
                        dropdownClassName="custom-dropdown"
                        showArrow
                    >
                        {categoryResponse?.data?.content?.map(item => (
                            <Select.Option value={item.productCategoryCode} key={item.productCategoryCode}>{item.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="startStatus">
                    <Select
                        className="custom-select home-search-select"
                        placeholder="Trạng thái"
                        dropdownClassName="custom-dropdown"
                    >
                        <Select.Option value={StartStatus.UPCOMING}>Sắp diễn ra</Select.Option>
                        <Select.Option value={StartStatus.ONGOING}>Đang diễn ra</Select.Option>
                        <Select.Option value={StartStatus.FINISH}>Đã kết thúc</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item name="title" style={{ flexGrow: 1 }}>
                    <Input maxLength={200} style={{ marginTop: 0 }} className="search-bar home-search-input" placeholder="Nhập từ khoá tìm kiếm ..." />
                </Form.Item>
                <div
                    onClick={() => form.submit()}
                    style={{
                        height: 60,
                        width: 60,
                        display: 'flex',
                        alignItems: 'center',
                        padding: 10,
                        borderRadius: '50%',
                        background: 'white',
                        border: '1px solid #DEDEDE',
                        cursor: 'pointer',
                        zIndex: 1,
                    }}>
                    <Search style={{ height: 25 }} />
                </div>
            </Form>
        </div>
    )
}

export default HomeSearch;